var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.431 5.57644L13.0305 5.08272C13.8429 4.4137 13.8429 3.16961 13.0305 2.50059C12.4129 1.99199 11.5217 1.99199 10.9041 2.50059L9.71589 3.47909C10.3658 4.44182 11.3135 5.18339 12.431 5.57644ZM8.16688 4.75474L4.44616 7.81887C3.93595 8.23904 3.68084 8.44913 3.50839 8.72415C3.33594 8.99918 3.25795 9.32032 3.10197 9.9626L2.93725 10.6409C2.85669 10.9726 2.8164 11.1385 2.90776 11.2369C2.99912 11.3354 3.16754 11.3077 3.50438 11.2522H3.50438L4.98569 11.0082C5.51358 10.9213 5.77752 10.8778 6.01825 10.7686C6.25898 10.6593 6.46547 10.4892 6.87846 10.1491L10.7081 6.99532C9.69752 6.45156 8.82875 5.68312 8.16688 4.75474Z",
    fill: "#20212C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.7c1f731189ac1024fd1f10312b351742.svg";
export { ForwardRef as ReactComponent };